import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setStep, updateSurvey } from 'store/actions';
import { VEHICLES_TYPES } from 'constants/survey'

import ProgressBar from 'components/ProgressBar/ProgressBar';
import Stepper from 'components/Stepper/Stepper';
import Step1 from 'components/Step1/Step1';
import Step2 from 'components/Step2/Step2';
import Step3 from 'components/Step3/Step3';
import Step4 from 'components/Step4/Step4';
import Step5 from 'components/Step5/Step5';
import Step6 from 'components/Step6/Step6';

const STEPS = [
  {
    id: '1',
    step: Step1,
  },
  {
    id: '2',
    step: Step2,
  },
  {
    id: '3',
    step: Step3,
  },
  {
    id: '4',
    step: Step4,
  },
  {
    id: '5',
    step: Step5,
  },
  {
    id: '6',
    step: Step6,
  }
];

const mapStateToProps = (state) => ({
  isLastStep: state.isLastStep,
  step: state.step,
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  setStep: (step) => dispatch(setStep(step)),
  updateSurvey: (survey) => dispatch(updateSurvey(survey))
});

class Recommender extends Component {
  constructor(props, context) {
    super(props);
  }

  componentDidMount() {
    const { t, survey, setStep, updateSurvey } = this.props;
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const vehicleTypeParam = params.get('vtype');
    const vehicleType = vehicleTypeParam ? VEHICLES_TYPES[vehicleTypeParam.toUpperCase()] : null;

    // Redirects to second step y vehicle type is passed in url param
    if(vehicleType) {
      // Update data from the last step
      const updatedSurvey = {
        ...survey,
        ...{vehicleType: t(vehicleType)},
      };

      updateSurvey(updatedSurvey);
      setStep(2);
    }
  }
  
  render() {
    const { isLastStep, step} = this.props;

    return (
      <section className="p-recommender">
        <div className="p-recommender__wrapper">
          <ProgressBar 
            extraClass="p-recommender__progress-bar"
            isLastStep={isLastStep}
            totalSteps={STEPS.length}
            currentStep={step} />
          <Stepper 
            steps={STEPS}
            activeStep={step} />
        </div>
      </section>
    );
  }
}

const ConnectedRecommender = connect(mapStateToProps, mapDispatchToProps)(Recommender);
export default withTranslation('translations')(ConnectedRecommender);
